const KEY = 'doral_cookie_consent';

export const getConsent = () => {
  try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; }
};

let gaLoaded = false;
export const loadGA4 = () => {
  if (gaLoaded || document.querySelector('script[src*="gtag/js"]')) return;
  gaLoaded = true;
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://www.googletagmanager.com/gtag/js?id=G-RPTN3FS0WL';
  document.head.appendChild(s);
  window.gtag('js', new Date());
  window.gtag('config', 'G-RPTN3FS0WL');
};

export const applyConsent = (c) => {
  if (!c) return;
  window.gtag('consent', 'update', {
    analytics_storage: c.analytics ? 'granted' : 'denied',
    ad_storage: c.marketing ? 'granted' : 'denied',
    ad_user_data: c.marketing ? 'granted' : 'denied',
    ad_personalization: c.marketing ? 'granted' : 'denied'
  });
  if (c.analytics) loadGA4();
};
